<template>
  <v-menu v-model="value" :location="location">
    <template #activator="{ props }">
      <v-btn v-bind="props" primary variant="flat" :class="{ activator: !title }">
        {{ title }}
        <v-icon v-if="icon" :end="!!title" color="white" :size="title ? 18 : 12">
          {{ icon }}
        </v-icon>
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="action in actions"
        :key="action.name"
        :disabled="action.disabled"
        @click="$emit(action.value)"
      >
        <v-list-item-title>{{ action.name }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    actions: {
      required: true,
      type: Array,
    },
    title: {
      required: false,
      type: String,
      default: null,
    },
    location: {
      required: false,
      validator: prop =>
        typeof prop === 'undefined' || ['top', 'bottom', 'start', 'end', 'center'].includes(prop),
      default: undefined,
    },
    icon: {
      required: false,
      type: String,
      default: 'mdi-dots-horizontal',
    },
  },
  data() {
    return { value: false };
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.activator {
  height: 12px !important;
  width: 25px !important;
  min-width: 25px !important;
  padding: 0 !important;
}
</style>
